import { MessageService } from '@progress/kendo-angular-l10n';
import { Provider } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KendoMessageService } from '../services/kendo-message.service';
import { languageHttpInterceptor } from '../interceptors/languageHttpInterceptor';
import { httpActivityInterceptor } from '../interceptors/httpActivityInterceptor';

export function provideKendoLocalization(): Provider[] {
  return [{ provide: MessageService, useClass: KendoMessageService }];
}
export function provideSharedInterceptors(): HttpInterceptorFn[] {
  return [languageHttpInterceptor, httpActivityInterceptor];
}
